export default {
    name: "FlowHeader",
    props: {
        isIndependent: {
            type: Boolean,
            required: false
        },
        isStafet: {
            type: Boolean,
            required: false
        }
    },
    setup(props){
        const closeFlow = function(returnUrl, forceUseReturn) {
            if (forceUseReturn || history.length <= 1)
            {
                document.location = returnUrl
                return
            }

            history.back()
        }

        return {
            closeFlow,
            isIndependent: props.isIndependent,
            isStafet: props.isStafet
        }
    }
}